import NiceModal from "@ebay/nice-modal-react";
import { adminRequester } from "App";
import P from "components/P";
import AdminCustomButton, { style } from "components/buttons/AdminCustomButton";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import PaddingWrapper from "layouts/wrapper/PaddingWrapper";
import ModalBase from "modals/base/ModalBase";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
const getDate = (date) => {
  date = new Date(date);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(date.getDate()).padStart(2, "0")} ${String(
    date.getHours()
  ).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
};

const PointModal = NiceModal.create((props) => {
  const { t } = useTranslation();
  // const { isMobile } = useContext(BrowserDetectContext);
  const { customer } = props;
  const [mounted, setMounted] = useState(false);
  const [withHeader, withFooter] = [true, false];
  const [width, height] = ["min(95%, 1280px)", "80vh"];
  const [data, setData] = useState([]);
  const [reload, setReload] = useState(false);
  const withCloseButton = true;
  const clickOutsideToClose = true;
  const modal = useRef();
  const headers = [
    {
      width: 50,
      label: "No.",
      code: "index",
      Cell: ({ index }) => index,
    },
    {
      label: "포인트",
      code: "metadata",
      Cell: ({ cell }) => Number(cell.point || 0),
    },
    {
      label: "누적포인트",
      code: "metadata",
      Cell: ({ cell }) => Number(cell.total || 0),
    },
    {
      label: "날짜",
      code: "created_at",
      Cell: ({ cell }) => (cell ? getDate(cell) : "오류"),
    },
    {
      label: "메모",
      code: "metadata",
      Cell: ({ cell }) => cell?.memo,
    },
  ];
  useEffect(() => setMounted(true), []);

  useEffect(() => {
    if (mounted) {
      adminRequester.getLogs(
        {
          search: customer.email,
          type: "포인트",
        },
        ({ logs }) => setData(logs)
      );
    }
  }, [mounted]);

  useEffect(() => {
    if (mounted && reload) {
      adminRequester.getLogs(
        {
          search: customer.email,
          type: "포인트",
        },
        ({ logs }) => setData(logs)
      );
      setReload(false);
    }
  }, [reload]);
  return (
    <ModalBase
      borderRadius={"10px"}
      headerStyle
      title={"포인트"}
      ref={modal}
      width={width}
      height={height}
      withHeader={withHeader}
      withFooter={withFooter}
      withCloseButton={withCloseButton}
      clickOutsideToClose={clickOutsideToClose}
    >
      <PaddingWrapper padding={30}>
        <div
          style={{
            height: "60vh",
            overflowY: "auto",
            border: "1px solid black",
            padding: 10,
          }}
        >
          <VerticalFlex gap={10} height="100%">
            <FlexChild height="max-content">
              <HorizontalFlex>
                {headers?.map((header, index) => (
                  <FlexChild
                    key={`${header?.label}_${index}`}
                    width={header?.width ? header.width : null}
                  >
                    <P weight="bold">{header?.label}</P>
                  </FlexChild>
                ))}
              </HorizontalFlex>
            </FlexChild>
            <FlexChild height="max-content">
              <VerticalFlex gap={10}>
                {data?.map((d, rowIndex) => {
                  return (
                    <HorizontalFlex key={d?.label}>
                      {headers.map((header, index) => {
                        let value = header?.Cell
                          ? header.Cell({
                              cell: d[header?.code],
                              row: d,
                              index: rowIndex,
                            })
                          : header?.code
                          ? d[header.code]
                          : "-";

                        if (
                          typeof value === "string" ||
                          typeof value === "number"
                        )
                          value = <P>{value}</P>;
                        return (
                          <FlexChild
                            key={`${header.label}_${index}_column`}
                            width={header?.width}
                          >
                            {value}
                          </FlexChild>
                        );
                      })}
                    </HorizontalFlex>
                  );
                })}
              </VerticalFlex>
            </FlexChild>
          </VerticalFlex>
        </div>
        <div style={{ height: 30 }} />
        <FlexChild>
          <HorizontalFlex justifyContent="center" gap={10}>
            <FlexChild width="max-content">
              <AdminCustomButton
                text="추가"
                onClick={() =>
                  NiceModal.show("addPoint", {
                    id: customer.id,
                    email: customer.email,
                    name: `${customer?.first_name ? customer.first_name : ""}${
                      customer?.first_name && customer.last_name ? " " : ""
                    }${customer?.last_name ? customer.last_name : ""}`,
                    point: customer.point,
                    setReload: (value) => {
                      setReload(value);
                      props?.setResearch?.(value);
                    },
                  })
                }
              />
            </FlexChild>
            <FlexChild width="max-content">
              <AdminCustomButton
                text="닫기"
                onClick={() => modal.current.close()}
              />
            </FlexChild>
          </HorizontalFlex>
        </FlexChild>
      </PaddingWrapper>
    </ModalBase>
  );
});

export default PointModal;
